import { render, staticRenderFns } from "./AppleLoginCallback.vue?vue&type=template&id=21688bc9"
import script from "./AppleLoginCallback.vue?vue&type=script&lang=js"
export * from "./AppleLoginCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports